import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-createnewbusinessuser',
  templateUrl: './createnewbusinessuser.component.html',
  styleUrls: ['./createnewbusinessuser.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CreatenewbusinessuserComponent {

}
